import { render, staticRenderFns } from "./ExampleTestQuestions.vue?vue&type=template&id=514d65be&"
import script from "./ExampleTestQuestions.vue?vue&type=script&lang=js&"
export * from "./ExampleTestQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ExampleTestQuestions.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports